import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/cssbuy-spreadsheet-guia-completo",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/como-usar-cssbuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/cssbuy-vs-outros-agents",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/top-sellers-sneakers-cssbuy-2026",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/cssbuy-vs-pandabuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/guia-envio-internacional-cssbuy",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/sellers-roupa-cssbuy-confiaveis",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/cssbuy-haul-review-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/cssbuy-qc-fotos-guia",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/cssbuy-spreadsheet-acessorios",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/erros-comuns-cssbuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/cssbuy-spreadsheet-atualizada",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;